import { createContext } from "react";
//@ts-ignore
export const SidebarContext = createContext();
